import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'
import useUpdateMode from '@hooks/useUpdateMode'
import { saveAnswer } from '@utils/onboardingStorage'
import { useSearchParams } from 'react-router-dom'

const QUESTION_KEY = 'biological_sex'

const answers: AnswerType[] = [
  {
    emoji: '👩‍🦰',
    title: 'pages.onboarding.biologicalSex.female',
    value: 'female',
  },
  {
    emoji: '👨',
    title: 'pages.onboarding.biologicalSex.male',
    value: 'male',
  },
]

export default function BiologicalSexPage() {
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value === 'female' || value === 'male' ? value : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const input = event.target as HTMLInputElement
    const sex = input.value

    const answer = {
      question_key: QUESTION_KEY,
      question: "What's your biological sex?",
      answer_key: sex.toLowerCase(),
      answer: sex,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
    }
  }

  return (
    <SingleChoiceQuestionPage
      answers={answers}
      title="pages.onboarding.biologicalSex.heading"
      onSubmit={onSubmit}
      preselectedValue={preselectedValue}
      withLogin
    />
  )
}
